import React, { useEffect, useLayoutEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { SubPageNavBox } from "../../../components/navBox/subPageNavBox";
import { getCookie } from "../../../util/cookie/cookies";
import { About } from "./about";
import { Liebherr } from "./liebherr";
import { Hyundai } from "./hyundai";
import { EquipmentStatus } from "./equipmentStatus";
import { PromotionCenter } from "./prCenter";
import { Contact } from "../aboutUs";
import { Products } from "../products";
import { EngineModeling } from "../../../components/EngineModeling";

export const SubPage = () => {
    const lang = getCookie('HYUNDAILANG')
    const location = useLocation();
    const path = location.pathname.split('/')
    const [data, setData] = useState<any>({title_1_kr:'',title_1_en:'',title_2_kr:'',title_2_en:'', className_1:'', className_2:''})
    useLayoutEffect(()=>{
        switch(path[1]){
            case 'about' : setData((prev:any)=>({...prev, title_1_kr :'회사소개', title_1_en : 'Company', className_1 : 'aboutUs'})); break;
            case 'liebherr' : setData((prev:any)=>({...prev, title_1_kr :'LIEBHERR', title_1_en : 'LIEBHERR', className_1 : 'liebherr'})); break;
            case 'hyundai' : setData((prev:any)=>({...prev, title_1_kr : 'HYUNDAI', title_1_en : 'HYUNDAI', className_1 : 'hyundai'})); break;
            case 'equipmentStatus' : setData((prev:any)=>({...prev, title_1_kr : '설비현황', title_1_en : 'Equipment Status', className_1 : 'equipment_status'})); break;
            case 'prCenter' : setData((prev:any)=>({...prev, title_1_kr : '홍보센터', title_1_en : 'Promotion Center', className_1 : 'pr_center'})); break;
            case 'contact' : setData((prev:any)=>({...prev, title_1_kr : '고객센터', title_1_en : 'Customer Center', className_1 : 'customer_service_center'}))
        }
    }, [location])
    return(
        <>
        <div className={`subPage ${data.className_1} ${data.className_2}`}>
            <div className="lnb">
                <div>
                    <h2>{lang==='kr'?data.title_2_kr:data.title_2_en}</h2>
                    <div>
                        <span>Home</span>
                        <span>{lang === 'kr'? data.title_1_kr : data.title_1_en}</span>
                        {path[1]==='equipmentStatus'? '' : 
                        <span>{lang==='kr'?data.title_2_kr:data.title_2_en}</span>}
                    </div>
                </div>
            </div>
            <SubPageNavBox/>
            {path[1]==='about' ? <About setData={setData}/> : ''}
            {path[1]==='liebherr' ? <Liebherr setData={setData}/> : ''}
            {path[1]==='hyundai' ? <Hyundai setData={setData}/> : ''}
            {path[1]==='equipmentStatus' ? <EquipmentStatus setData={setData}/> : ''}
            {path[1]==='prCenter'? <PromotionCenter setData={setData}/> : ''} 
            {path[1]==='contact'? <Contact setData={setData}/> : ''}
        </div>
        </> 
    )
}